import React, { FC, Fragment } from 'react';
import { Grid } from '@material-ui/core';
import { times } from 'lodash';

import { LoaderComponents, PaddedPaper } from 'components';

const Loader: FC = () => {
  const { Block, Image } = LoaderComponents;

  return (
    <Grid container spacing={2}>
      {times(4, rowIndex => (
        <Fragment key={rowIndex}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <PaddedPaper>
              <Grid container direction="column" alignItems="center" wrap="nowrap" spacing={2}>
                <Grid item>
                  <Image shape="circle" height={100} width={100} />
                </Grid>
                <Grid item>
                  <Block width={150} />
                </Grid>
                <Grid item>
                  <Block width={150} />
                </Grid>
                <Grid item>
                  <Block height={35} width={100} />
                </Grid>
              </Grid>
            </PaddedPaper>
          </Grid>
        </Fragment>
      ))}
    </Grid>
  );
};

export default Loader;
